import { sentenceCase } from 'utils/stringHelpers';
import { FILTER_MAPPINGS } from './constants';
import {
  CurrentProjectStatus,
  Organization,
  Project,
  ScheduleTypes,
  Status,
  Sync,
  SyncSchedule,
} from './types';

export const formatSyncSchedule = ({ data, type }: SyncSchedule) => {
  try {
    /**
     * Interval schedule
     * Initial response does not include `data` only a `type`
     * To avoid errors, check that quantity and unit are available or move on
     * to default return statement
     */
    if (type === ScheduleTypes.Interval && data?.quantity && data?.unit) {
      const { quantity, unit } = data;
      return quantity === 1 ? `Every ${unit}` : `Every ${quantity} ${`${unit}s`}`;
    }

    // need to provide better formatting for other types of schedules
    return sentenceCase(type);
  } catch (error) {
    return '';
  }
};

export const getIterableSyncStatus = (status: Status) => {
  const currentStatus = FILTER_MAPPINGS[status].label;
  return currentStatus || 'Unknown';
};

export const filterSyncs = (syncs: Sync[], search: string, status: string[]) =>
  syncs.filter((sync) => {
    const isKeywordMatch = !search || sync.name.toLowerCase().includes(search.toLowerCase());
    const { id } = FILTER_MAPPINGS[sync.status];
    const isStatusMatch = !status.length || status.includes(id);

    return isKeywordMatch && isStatusMatch;
  });

/** Distinguish between test and production projects, and not implemented in case of errors or edge cases */
export const getCurrentProjectStatus = (projectId: number, projects: Project[] = []) => {
  const currentProject = projects.find((project) => project.id === projectId);
  if (!currentProject) {
    return CurrentProjectStatus.NOT_IMPLEMENTED;
  }

  return currentProject?.isBillable ? CurrentProjectStatus.PRODUCTION : CurrentProjectStatus.TEST;
};

/** Get a number of remaining syncs, zero or greater */
export const getRemainingSyncs = ({
  allotment,
  productionSyncsCount,
}: Pick<Organization, 'allotment' | 'productionSyncsCount'>) => {
  const remainingSyncs = Math.max(allotment - productionSyncsCount, 0);
  return remainingSyncs;
};

/** Determine if org is at sync limit for production syncs */
export const shouldRestrictCreation = (
  currentProjectStatus: CurrentProjectStatus,
  remainingSyncs: number,
) => {
  const isProductionProject = currentProjectStatus === CurrentProjectStatus.PRODUCTION;
  const shouldRestrict = remainingSyncs <= 0 && isProductionProject;
  return shouldRestrict;
};
